import React from 'react';

export const AppLogoContext = React.createContext({
    hideSplashScreen(target): Promise<any> {
        return Promise.resolve();
    },
});
